// extracted by mini-css-extract-plugin
export default {"root":"widget_root__fRnnz","dropShadow":"widget_dropShadow__O7oaR","title":"widget_title__XOE43","description":"widget_description__i2ihr"};